module.exports = __webpack_public_path__ + "static/media/topology~bpTnfhXY.9afc1a2c.png";